import React from 'react';
import '../assets/styles/ComingSoon.css';
import checkIcon from '../assets/images/check-coming soon.svg';
import phoneIcon from '../assets/images/phonenumbericon.svg';

const ComingSoon = () => {
  return (
    <section className="coming-soon">
      <div className="overlap-group">
        <div className="frame">
          <div className="content">
            {/* Title Section */}
            <div className="title-section">
              <div className="most-popular-tag">
                <div className="text-wrapper">COMING SOON</div>
              </div>
              <p className="transforming-homes">
                Transforming Homes into <br className="d-none d-md-block" />
                Hassle-Free Income Streams
              </p>
              <p className="div">
                Rent out and maintain your property effortlessly while we handle everything.
              </p>
            </div>

            {/* Bullet Points */}
            <div className="points w-100">
  {[
    'List properties for short or long-term stays',
    'End-to-end property management',
    'Seamless maintenance & cleaning',
    'Secure payments & bookings',
  ].map((text, index) => (
    <div
      key={index}
      className="d-flex align-items-start w-100 mb-2"
      style={{ flexWrap: 'nowrap' }}
    >
      <img
        src={checkIcon}
        alt="check"
        className="me-2 flex-shrink-0"
        style={{ width: '24px', height: '24px' }}
      />
      <p
        className="mb-0 text-black"
        style={{
          fontSize: '18px',
          lineHeight: '26px',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          flex: '1 1 auto',
        }}
      >
        {text}
      </p>
    </div>
  ))}
</div>


          </div>

          {/* Button */}
          <div className="primary-btn-medium mt-4">
            <p className="primary-button">Sign Up to Stay Updated</p>
            <img className="btn-icon" src={phoneIcon} alt="Sign up" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
